// extracted by mini-css-extract-plugin
export default {"scoreboardEntry":"ScoreboardEntry_scoreboardEntry__KZC3h","selectedEntry":"ScoreboardEntry_selectedEntry__uWG15","score":"ScoreboardEntry_score__EckVB"};